import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: 'app-confirm-remove-blacklisted-dialog',
  templateUrl: './confirm-remove-blacklisted-dialog.component.html',
  styleUrls: ['./confirm-remove-blacklisted-dialog.component.scss']
})
export class ConfirmRemoveBlacklistedDialogComponent implements OnInit {
  constructor(
    private _router: Router,
    private dialogRef: MatDialogRef<ConfirmRemoveBlacklistedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {}

  confirmDialog(): void {
    this.dialogRef.close(true);
  }

}
